<template>
  <CreateEditUserModal
    v-if="showCreateEditUserModal"
    :userId="userId"
    @closeModal="closeCreateEditUserModal"
  />
  <ResetPasswordUserModal
    v-if="showResetPasswordUserModal"
    :userId="userId"
    @closeModal="showResetPasswordUserModal = false"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Detalhes do Usuário</h6>
      <div class="ms-auto">
        <router-link
          to="/users"
          class="btn btn-outline-dark"
          title="Listagem de Usuários"
        >
          Listagem de Usuários
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <p><strong>Nome:</strong> {{ user.name }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p><strong>Chapa:</strong> {{ user.chapa ? user.chapa : '-' }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Cargo: </strong>
            <router-link
              :to="`/roles/${user.roleId}`"
              title="Visualizar detalhes do cargo"
            >
              {{ user.roleName }}
            </router-link>
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Forma de Autenticação:</strong>
            {{ user.formAuthentication === '1' ? 'E-mail' : 'Nome de Usuário' }}
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Nome de Usuário:</strong>
            {{ user.nickname ? user.nickname : '-' }}
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p><strong>E-mail:</strong> {{ user.email ? user.email : '-' }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p><strong>Telefone:</strong> {{ user.phone ? user.phone : '-' }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Admin: </strong>
            <span class="text-uppercase">
              {{ user.isAdmin === '1' ? 'Sim' : 'Não' }}
            </span>
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Status: </strong>
            <span v-html="statusTranslate(user.status)" />
          </p>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex justify-content-between align-items-center">
      <ul class="list-inline text-muted mb-0">
        <li class="list-inline-item">
          Cadastro por:
          {{ createdUpdatedUser(user.createdBy, user.createdAt) }}
        </li>
        <li class="list-inline-item">
          Atualizado por:
          {{ createdUpdatedUser(user.updatedBy, user.updatedAt) }}
        </li>
      </ul>
      <div class="w-50 text-end">
        <button
          type="button"
          class="btn btn-teal"
          title="Resetar Senha"
          @click="showResetPasswordUserModal = true"
        >
          Resetar Senha
        </button>
        <button
          type="button"
          class="btn btn-warning ms-2"
          title="Editar Usuário"
          @click="showCreateEditUserModal = true"
        >
          Editar Usuário
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPasswordUserModal from '@/components/users/ResetPasswordUserModal.vue'
import CreateEditUserModal from '@/components/users/CreateEditUserModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'
import PATHS from '@/router/routesMap'

export default {
  name: 'DetailsUser',

  components: {
    ResetPasswordUserModal,
    CreateEditUserModal,
    LoadingData,
  },

  props: {
    userId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditUserModal: false,
      showResetPasswordUserModal: false,
      user: {},
      createdUpdatedUser,
      statusTranslate,
    }
  },

  methods: {
    async getUser() {
      try {
        this.user = await this.$store.dispatch('getUser', this.userId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$router.push(PATHS.HOME)
      }
    },

    closeCreateEditUserModal(loadUser) {
      if (loadUser) {
        this.getUser()
      }
      this.showCreateEditUserModal = false
    },
  },

  mounted() {
    this.getUser()
  },
}
</script>
